import '../../../css/group-workspace.css';

// Fixed palette, picked by a deterministic hash of the student id - same
// student always gets the same color everywhere this renders (not
// re-randomized per render), while different students still end up visibly
// distinct at a glance without needing a real per-student color field
// anywhere in the data model.
const AVATAR_COLORS = ['#e0533a', '#4dd68c', '#7ec2e8', '#e0a35c', '#c792ea', '#f28fb1', '#63dac8', '#ffb86b'];

function colorForStudent(studentId) {
   const n = Math.abs(Number(studentId)) || 0;
   return AVATAR_COLORS[n % AVATAR_COLORS.length];
}

// Compact colored initial-letter avatar - hover (native title tooltip) shows
// the full name. Used wherever a merged group view needs to say "this
// specific piece belongs to this specific member" without spelling the name
// out inline every time (see GroupExerciseAnswerState.jsx).
export default function StudentAvatar({ studentId, name }) {
   const initial = (name || '?').trim().charAt(0).toUpperCase() || '?';
   return (
      <span className='student-avatar-dot' style={{ '--avatar-color': colorForStudent(studentId) }} title={name || ''}>
         {initial}
      </span>
   );
}
